import { useMutation } from '@tanstack/react-query';

import { useUpdateTimeZoneFetcher } from './useUpdateTimezoneFetcher';

export type UpdateUserTimeZone = {
  timeZone: string;
};

const path = '/gateway/profile/timezone';

export const useUpdateTimeZone = () => {
  const fetcher = useUpdateTimeZoneFetcher();

  return useMutation((args: UpdateUserTimeZone) => {
    return fetcher({ path, ...args });
  });
};
